import { CURRENT_TENANT } from "./tenant";
// Feature flags can be:
// - Enabled globally: true
// - Disabled globally: false
// - Enabled only for specific tenants: FEATURE_ENABLED_TENANTS.includes(CURRENT_TENANT)

const FEATURE_ENABLED_TENANTS = ["dummydev",];

export const USE_CHARGEBEE_HOSTED_PAGES = true;

export const USE_NEW_SUBSCRIPTION_DESIGN = true;

export const USE_CUSTOMER_CREATION_TEMPORARY_FIX = false; 

// Adds a Messaging Tab in the Reservation Modal
export const USE_MESSAGING_IN_RESERVATION_MODAL = true;

// Use the new Notification Center
export const USE_NOTIFICATION_CENTER = true;

// New button and modal in the reservation view to manage shifts
export const USE_MANAGE_SHIFT = true;

// In the Reservation Modal, the Cancel Reservation Button & Modal now has a checkbox to permanently delete the reservation
export const USE_DELETE_RESERVATION = true;

// Allows the export of all reservations from the Reservations History
export const USE_EXPORT_RESERVATIONS = true;

// Display Announce Kit tab in the Notification Center
export const USE_ANNOUNCE_KIT = true;

// Use the new UI and new improvements for the Booker page.
export const USE_NEW_BOOKER_UI = true;

// Allows the edition of a reservation comment by the user
export const USE_COMMENT_EDITION = false;

export const USE_CALENDAR_V2 = FEATURE_ENABLED_TENANTS.includes(CURRENT_TENANT);

export const USE_SHIFT_CONFLICT_MODAL = false;

export const USE_ANSWERING_MACHINE = FEATURE_ENABLED_TENANTS.includes(CURRENT_TENANT);



// WEBPACK FOOTER //
// ./src/constants/featureFlags.js